angular.module('core')
  .service('dblAlertApi', [
        '$interpolate',
        'cancelableResourceFactory',
        'cancelableResourceManager',
        'transformResponse',
    function (
        $interpolate,
        cancelableResourceFactory,
        cancelableResourceManager,
        transformResponse
    ) {

    var LESSON_GROUP_ALERT_TEXT = '{{studentName}} may need assistance on <strong>{{lessonGroupName}}</strong>.';
    var LESSONS_FAILED_ALERT_TEXT = '{{studentName}} was not proficient in three of the last five completed lessons.';
    var STANDARD_ALERT_TEXT = '{{studentName}} may need assistance on <strong>{{standardLabel}}</strong>.';

    var ClassroomAlerts = cancelableResourceFactory.createCacheableResource(null, '/r/districts/:districtId/classrooms/:classroomId/alerts/academic', {}, {
      get: {
        method: 'GET',
        isArray: true,
        cache: false,
        transformResponse: transformResponse.transformResponseToJson
      }
    });

    this.getClassroomAlerts = function (districtId, classroomId, ast, days, fd, td) {
        var params = {
            districtId: districtId,
            classroomId: classroomId,
            ast: ast,
            untilNow: true,
            days: days,
            fd: fd,
            td: td
        };

        var resource = ClassroomAlerts.get(params);
        cancelableResourceManager.addAndRemoveOnFinish(resource);

        return resource.$promise;
    };

    var buildAlertText = function (alert, studentName) {
        var text = '';
        var context = {
            studentName: studentName
        };

        switch (alert['@type']) {
            case 'StandardStrugglingAlert':
                context.standardLabel = alert.standard_label;
                text = $interpolate(STANDARD_ALERT_TEXT)(context);
            break;
            case 'LessonsFailThresholdAlert':
                text = $interpolate(LESSONS_FAILED_ALERT_TEXT)(context);
            break;
            case 'LessonGroupStrugglingAlert':
                context.lessonGroupName = alert.short_description;
                text = $interpolate(LESSON_GROUP_ALERT_TEXT)(context);
            break;
        }

        return text;
    };

    this.buildAlertText = buildAlertText;

    this.getClassroomAlertsWithText = function (districtId, classroomId, ast, days, fd, td) {
        var params = {
            districtId: districtId,
            classroomId: classroomId,
            ast: ast,
            untilNow: true,
            days: days,
            fd: fd,
            td: td
        };

        var resource = ClassroomAlerts.get(params);
        cancelableResourceManager.addAndRemoveOnFinish(resource);

        return resource.$promise.then(function (studentAlertsResponse) {
            _.each(studentAlertsResponse, function (student) {
                _.each(student.academic_alerts, function (alert) {
                    alert.text = buildAlertText(alert, student.first_name);
                });
            });

            return studentAlertsResponse;
        });
    };

}]);
